import { render, staticRenderFns } from "./ContestReadOnlyOfferActivitiesDescriptionView.vue?vue&type=template&id=69560f4b&scoped=true&"
import script from "./ContestReadOnlyOfferActivitiesDescriptionView.vue?vue&type=script&lang=js&"
export * from "./ContestReadOnlyOfferActivitiesDescriptionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69560f4b",
  null
  
)

export default component.exports